<template>
  <div class="modifyMail">
    <van-nav-bar
      class="nav_bar"
      :title="usermail?'更换安全邮箱':'绑定安全邮箱'"
      left-arrow
      placeholder
      @click-left="$router.back()"
    />
    <!-- 更换绑定 -->
    <div v-if="usermail" class="toModify">
      <div class="progress" v-if="modifyEmailStep != 3">
        <div class="outer-1" :class="{active:modifyEmailStep >= 1}">
          <div class="inner">1</div>
          <span class="txt">验证身份</span>
        </div>
        <div class="outer-2" :class="{active:modifyEmailStep >= 2}">
          <div class="inner">2</div>
          <span class="txt">修改邮箱</span>
        </div>
        <div class="outer-3" :class="{active:modifyEmailStep == 3}">
          <div class="inner">3</div>
          <span class="txt">完成更换</span>
        </div>
      </div>
      <div class="form"> 
        <template v-if="modifyEmailStep == 1">
          <div class="desc">
            <p class="desc1">已绑定的邮箱：<span style="color:#1972FF;">{{usermail}}</span></p>
            <p class="desc2">若该邮箱账号无法使用请联系客服</p>
          </div>
          <div class="inputWrapper authcodeInputWrapper">
            <van-field
              v-model="mailCode"
              class="inputItem authcodeInput"
              clearable
              placeholder="请输入验证码"
              :border="false"
            />
            <div class="getVerificationStyle fr" @click="postAccountGetAuthCode('oldphone')" :style="{color:Countdown>0? '#BBBBBB':'#333333'}">
              {{VerificationStatus}}
            </div>
          </div>
        </template>
        <template v-if="modifyEmailStep == 2">
          <div class="inputWrapper phoneInput">
            <van-field
              v-model="modifyAccount.account"
              class="inputItem"
              center
              clearable
              :border="false"
              placeholder="请输入邮箱地址"
            />
          </div>
          <div class="inputWrapper authcodeInputWrapper">
            <van-field
              v-model="modifyAccount.authCode"
              class="inputItem authcodeInput"
              center
              clearable
              placeholder="请输入验证码"
              :border="false"
            />
            <div class="getVerificationStyle fr" @click="postAccountGetAuthCode('newphone')" :style="{color:Countdown>0? '#BBBBBB':'#333333'}">
              {{VerificationStatus}}
            </div>
          </div>
        </template>
        <template v-if="modifyEmailStep == 3">
          <div class="modifySuccess">
            <img src="../../../assets/images/account/genghuanchenggong.png" alt="">
            <div class="success_title">邮箱更换成功</div>
            <div class="success_tip">请在下次使用新的邮箱进行登录</div>
            <div class="success_btn" @click="$router.back()">返回</div>
          </div>
        </template>
        <div class="OperatingSpace" v-if="modifyEmailStep != 3">
          <van-button
              round type="info"
              :class="modifyMailBtnColor ? 'noneVanButton' : 'van-button--info'"
              @click="handlemodifyMail(modifyEmailStep)"
          >下一步</van-button>
        </div>
      </div>
    </div>
    <!-- 去绑定 -->
    <div v-else class="toBind">
      <div class="inputWrapper">
        <van-field
          v-model="modifyAccount.account"
          class="inputItem"
          center
          clearable
          :border="false"
          placeholder="请输入邮箱地址"
        />
      </div>
      <div class="inputWrapper authcodeInputWrapper">
        <van-field
          v-model="modifyAccount.authCode"
          class="inputItem authcodeInput"
          center
          clearable
          placeholder="请输入验证码"
          :border="false"
        />
        <div class="getVerificationStyle fr" @click="postAccountGetAuthCode('newphone')" :style="{color:Countdown>0? '#BBBBBB':'#333333'}">
          {{VerificationStatus}}
        </div>
      </div>
      <div class="OperatingSpace">
        <van-button
            round type="info"
            :class="modifyMailBtnColor ? 'noneVanButton' : 'van-button--info'"
            @click="handleBind"
        >确定</van-button>
      </div>
    </div>
      
  </div>
</template>

<script>
import { isEmail } from '../../../utils/validate'
export default {
    name:'modifyMail',
    data(){
      return{
        usermail:'',
        Countdown:0,
        modifyEmailStep:1,
        modifyAccount:{
          account:'',
          authCode:''
        },
        mailCode:'',//验证身份
      }
    },
    computed:{
      VerificationStatus () {
        if (this.Countdown) {
          return `重新获取 ${this.Countdown}s`
        } else {
          return '发送验证码'
        }
      },
      modifyMailBtnColor(){
        //绑定邮箱账号
        if(!this.usermail){
          if(!this.modifyAccount.account || !this.modifyAccount.authCode){
            return true
          }else{
            return false
          }
        }
        // 换绑邮箱账号
        if(this.modifyEmailStep == 1 && !this.mailCode){
            return true
        }else if(this.modifyEmailStep == 2 && (!this.modifyAccount.account || !this.modifyAccount.authCode)){
            return true
        }else{
            return false
        }
      },
    },
    mounted(){
      this.usermail = this.$route.query.usermail
    },
    methods:{
      // 更换邮箱 发送验证码
      async postAccountGetAuthCode(type) {
        let account = type === 'oldphone'? this.usermail:this.modifyAccount.account 
        const data = { account,type:2 };
        this.modifyAccount.authCode = null;
        if (isEmail.test(account)) {
            if (this.Countdown > 0) return;
            this.Countdown = 60;
            this.setCountdown();
            this.$sensors.track('UM_Click_Verification_Code_Button')
            this.$api.usercenter.getAuthCodePublic({ data })
        }else{
            this.$notify({ type: 'danger', message: '请输入正确的邮箱账号'})
        }
      },
      setCountdown() {
        this.CountdownInterval = setInterval(() => {
          this.Countdown--;
          if (this.Countdown <= 0) {
            clearInterval(this.CountdownInterval);
          }
        }, 1000);
      },
      // 更换邮箱操作
      handlemodifyMail(step){
        if(step == 1){
          this.checkAuthCode()
        }else if(step == 2){
          this.unBindUserAccount('phone')
        }
      },
      // 更换邮箱账号
      unBindUserAccount(){
        if(!this.checkMail()) return
        let params = {...this.modifyAccount}
        this.$api.usercenter.unBindUserAccount(params).then(res=>{
          if(res.data){
            this.modifyEmailStep = 3
          }
        })
      },
      // 验证身份
      checkAuthCode(){
        if(!this.mailCode){
          this.$notify({ type: 'danger', message: '验证码不能为空'})
          return 
        }
        let result = false
        let data = { account:this.usermail,authCode:this.mailCode }
        this.$api.usercenter
          .checkAuthCode(data)
          .then(res => {
              result = res.data
              if(result){
                  this.modifyEmailStep = 2
                  clearInterval(this.CountdownInterval)
                  this.Countdown = 0
              }
          });
      },
      // 绑定邮箱账号
      handleBind(){
        if(!this.checkMail()) return
        let params = {...this.modifyAccount}
        this.$api.usercenter.bindUserAccount(params).then(res=>{
          if(res.data){
            this.$toast({
              message:'邮箱账号绑定成功',
              onClose:() => {
                this.$router.back()
              }
            })
          }
        })
      },
      checkMail(){
        if (!isEmail.test( this.modifyAccount.account )) {
          this.$notify({ type: 'danger', message: '请输入正确的邮箱账号'})
          return false
        }
        if(!this.modifyAccount.authCode){
          this.$notify({ type: 'danger', message: '验证码不能为空'})
          return false
        }
        return true
      }
    }
}
</script>

<style lang="stylus" scoped>
  .progress{
    position relative
    width 528px
    margin 0 auto
    .outer-1,.outer-2,.outer-3{
      position relative
      display inline-block
      // top -40px 
      width 80px
      height 80px
      line-height 80px
      text-align center
      background rgba(215, 215, 215, 0.2)
      border-radius 50%
      &.active{
        background rgba(25, 114, 255, 0.2)
        .inner{
          background #1972FF
        }
        .txt{
          color #1972FF
        }
      }
      .inner{
        display inline-block
        width 64px
        height 64px
        background #D7D7D7
        border-radius 50%
        line-height 64px
        text-align center
        color #ffffff
      }
      .txt{
        font-size 28px
        font-family PingFangSC-Regular, PingFang SC
        color #BBBBBB
        line-height 28px
        position absolute
        left 50%
        top 100px
        transform translateX(-50%)
        width 170px
      }
    }
    .outer-2{
      margin 0 144px
      margin-top 40px
      &::before{
        content:''
        display block
        position absolute
        left -120px
        top 50%
        transform translateY(-50%)
        width 96px
        height 2px
        background #3660FF
        border-radius 2px
        opacity 0.1
      }
      &::after{
        content:''
        display block
        position absolute
        right -120px
        top 50%
        transform translateY(-50%)
        width 96px
        height 2px
        background #3660FF
        border-radius 2px
        opacity 0.1
      }
    }
  }
  .form{
    width 690px
    margin 0 auto
  }
  .desc{
    width 690px
    box-sizing border-box
    padding 40px 0
    margin 0 auto
    margin-top 80px
    margin-bottom 64px
    border-radius 6px
    background #F5F6FA
    font-size 28px
    font-family PingFangSC-Regular, PingFang SC
    font-weight 400
    color #333333
    text-align center
    .desc1,.desc2{
      line-height 1
    }
    .desc1{
      margin-bottom 24px
    }
  }
  .inputWrapper {
    width 622px
    margin 0 auto
    display flex
    align-items center
    height 128px
    border-bottom 1px solid #D7D7D7
    box-sizing border-box
    .inputItem{
      // width 470px
      // display inline-block
      padding 0
      height 58px
      line-height 58px
      font-size 36px
      font-family PingFangSC-Medium, PingFang SC
      font-weight 500
      color #CCCCCC
      background transparent
    }
  }
  .authcodeInputWrapper{
    justify-content space-between
    .authcodeInput{
      width 430px
      display inline-block
    }
    .getVerificationStyle{
      color #333333
      font-size 30px
      font-family PingFangSC-Regular, PingFang SC
    }
  }
  .phoneInput{
    margin-top 112px
  }
  .OperatingSpace{
    width 622px
    position relative
    margin-left -311px
    left 50%
    span{
        color #333333
        font-size 30px
    }
    .van-button{
        width 100%
        height 44px
        line-height 44px
        margin-top 32px
        margin-bottom 24px
        span{
            color #FFFFFF
            font-size 16px
        }
    }
    .noneVanButton{
        background-color #C0D5FF
        border 1px solid #C0D5FF
    }
    .van-button--info{
        background-color linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
        border 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
    }
  }
  .modifySuccess{
    display flex
    align-items center
    flex-direction column
    >img {
      width 400px
      height 400px
    }
    .success_title{
      font-size 36px
      font-family PingFangSC-Regular, PingFang SC
      color #202124
      line-height 1
    }
    .success_tip{
      margin 32px 0 80px 0
      font-size 28px
      font-family PingFangSC-Regular, PingFang SC
      color #BBBBBB
      line-height 1
    }
    .success_btn{
      width 236px
      height 80px
      font-size 32px
      font-family PingFangSC-Regular, PingFang SC
      color #1972FF
      text-align center
      line-height 80px
      border-radius 44px
      border 1px solid #1972FF
    }
  }
  .toBind{
    width 622px
    margin 0 auto
  }
</style>